import { useState } from "react";
import { title } from "../utils/style";
import 'react-toastify/dist/ReactToastify.css';
import B2CWorkOrderAuditLog from "../child_components/B2CWorkOrderAuditLog.js";
import B2BWorkOrderAuditLog from "../child_components/B2BWorkOrderAuditLog.js";

function WorkOrderAuditLog() {
  const [isB2b, setIsB2b] = useState(true);
  return (
    <div className='min-h-screen bg-gray-50 p-6'>
      <div className='flex justify-between items-start mb-6'>
        <div>
          <div className={`${title} flex justify-between`}>
            <p> Work Order Versioning </p>
            <div className="flex border border-gray-300 rounded-full overflow-hidden">

              <button className={`px-4 py-1 text-sm font-medium ${isB2b ? "bg-blue-500 text-white" : "bg-white text-gray-600"}`} onClick={() => setIsB2b(true)}>
                B2B
              </button>
              <button className={`px-4 py-1 text-sm font-medium ${!isB2b ? "bg-blue-500 text-white" : "bg-white text-gray-600"}`} onClick={() => setIsB2b(false)}>
                B2C
              </button>
            </div>
          </div>
          <p className='text-gray-600 text-sm'>
            Track changes and maintain version history for work orders
          </p>
        </div>
      </div>

      {isB2b ? <B2BWorkOrderAuditLog /> : < B2CWorkOrderAuditLog />}

    </div >
  );
}

export default WorkOrderAuditLog;